import { render, staticRenderFns } from "./MainPartners.vue?vue&type=template&id=8aae0082&"
import script from "./MainPartners.vue?vue&type=script&lang=js&"
export * from "./MainPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports